<div class="flex">
  <div class="flex-1 separator pr-small-r mr-small-r overflow-hidden">
    <fcom-timeline
      *ngIf="arrival && departure"
      [arrival]="arrival"
      [departure]="departure"
      [isByBusOnly]="isByBusOnly"
    ></fcom-timeline>
  </div>
  <div class="bound-details flex" [style.minWidth]="0">
    <div *ngIf="tails.length" class="flex--nogrow flex mr-xxsmall-r ms-xxsmall-b" aria-hidden="true">
      <div
        *ngFor="let tail of tails; let i = index"
        class="flex--nogrow tail {{ tail }}"
        [class.first]="i === 0"
        [class.minus-margin]="i !== 0"
      ></div>
    </div>

    <div class="font-body-2 flex flex--column grow">
      <div *ngIf="airlines.length > 0" class="flex--nogrow nordic-blue-900-text">
        <span class="is-vishidden">
          {{ 'bookingSummary.operatedBy' | finLocalization }}
        </span>
        {{ airlines.join(', ') }}
      </div>

      <div *ngIf="duration || stops !== undefined" class="flex--nogrow flex flex--wrap overflow-hidden">
        <span *ngIf="duration" class="truncate overflow-hidden"
          >{{ duration }}<span *ngIf="stops !== undefined">,&nbsp;</span>
        </span>
        <span class="truncate overflow-hidden" *ngIf="stops !== undefined" [ngSwitch]="stops">
          <!-- TODO: use global translation key instead of booking translation key -->
          <ng-container class="" *ngSwitchCase="0">{{ 'bookingSummary.direct' | finLocalization }}</ng-container>
          <!-- TODO: use global translation key instead of booking translation key -->
          <ng-container *ngSwitchCase="1">{{ 'stopOver' | finLocalization: [stops] }}</ng-container>
          <!-- TODO: use global translation key instead of booking translation key -->
          <ng-container *ngSwitchDefault>{{ 'stopOvers' | finLocalization: [stops] }}</ng-container>
        </span>
      </div>

      <div *ngIf="showViewDetails" class="flex-2 flex flex--align-end ms-xxsmall-t">
        <!-- TODO: use global translation key for view Details instead of booking translation key -->
        <button
          class="font-body-1 nordic-blue-900-text blue-light-hover medium-type underline overflow-hidden align-left"
          #viewDetailsBtn
          (click)="viewDetails.emit($event)"
        >
          {{ viewDetailsBtnKey | finLocalization }}
        </button>
      </div>
    </div>
  </div>
</div>
